import { createContext } from "react";

export type ThemeMode = "light" | "dark";

export interface ThemeModeContextValue {
  mode: ThemeMode;
  toggleMode: () => void;
}

export const ThemeModeContext = createContext<
  ThemeModeContextValue | undefined
>(undefined);

export const THEME_MODE_STORAGE_KEY = "portal-theme-mode";
